import { useEffect, useState } from "react";
import { Footprints, DoorOpen } from "lucide-react";

const t = (iso) => new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
const mins = (a, b) => Math.max(0, Math.round((new Date(b) - new Date(a)) / 60000));

export default function VisitStatus({ request, helperName, compact = false }) {
  const [, tick] = useState(0);
  useEffect(() => { const i = setInterval(() => tick((n) => n + 1), 60000); return () => clearInterval(i); }, []);
  const name = (helperName || request.helper_name || request.helper?.name || "Your helper").split(" ")[0];
  if (request.status === "in_progress" && request.arrived_at) {
    return (
      <p data-testid="visit-status-live" className={`flex items-center gap-2 font-semibold text-[#1F5F4F] ${compact ? "text-sm" : ""}`}>
        <span className="relative flex w-3 h-3"><span className="absolute inline-flex w-full h-full rounded-full bg-[#2E7D6B] opacity-60 animate-ping" /><span className="relative inline-flex w-3 h-3 rounded-full bg-[#2E7D6B]" /></span>
        <Footprints className="w-4 h-4" /> {name} arrived at {t(request.arrived_at)} · with you for {mins(request.arrived_at, Date.now())} min
      </p>
    );
  }
  if (request.status === "completed" && request.arrived_at && request.completed_at) {
    return (
      <p data-testid="visit-status-done" className={`flex items-center gap-2 text-slate-700 ${compact ? "text-sm" : ""}`}>
        <DoorOpen className="w-4 h-4 text-[#2E7D6B]" /> {name} arrived {t(request.arrived_at)}, left {t(request.completed_at)} ({mins(request.arrived_at, request.completed_at)} min)
      </p>
    );
  }
  return null;
}
